import React from 'react';
import { Modal } from '../Modal';
import { SignupForm } from '../SignupForm';
import { useDeviceInfo } from '../../hooks/useDeviceInfo';
import { ModalLoginForm } from '../ModalLoginForm';
import { MagicLink } from '../MagicLink';
import { connect } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
export var signupCopy = {
  login: {
    title: 'Please enter your email address',
    buttonText: 'Continue'
  },
  signup: {
    title: 'Sign up to continue',
    buttonText: 'Sign up'
  }
};

var SignupFlow = function SignupFlow(_ref) {
  var email = _ref.email,
      loadingAuth = _ref.loadingAuth,
      step = _ref.step,
      _ref$copy = _ref.copy,
      copy = _ref$copy === void 0 ? signupCopy : _ref$copy,
      onLoginFormSubmit = _ref.onLoginFormSubmit,
      onSignupFormSubmit = _ref.onSignupFormSubmit,
      setStep = _ref.setStep;
  var deviceInfo = useDeviceInfo();

  var setModal = function setModal(_ref2) {
    var show = _ref2.show;

    if (!show) {
      setStep(null);
    }
  };

  var renderSignuUpModalContent = function renderSignuUpModalContent() {
    switch (step) {
      case 'login':
        return /*#__PURE__*/_jsx("div", {
          style: {
            width: deviceInfo.desktop || deviceInfo.iPad ? 445 : '100%',
            padding: "0 ".concat(deviceInfo.desktop || deviceInfo.iPad ? '40px' : '0')
          },
          children: /*#__PURE__*/_jsx(ModalLoginForm, {
            title: copy.login.title,
            buttonText: copy.login.buttonText,
            loading: loadingAuth,
            onSubmit: onLoginFormSubmit
          })
        });

      case 'enter-email':
        return /*#__PURE__*/_jsx("div", {
          style: {
            width: deviceInfo.desktop || deviceInfo.iPad ? 445 : '100%',
            padding: "0 ".concat(deviceInfo.desktop || deviceInfo.iPad ? '40px' : '0')
          },
          children: /*#__PURE__*/_jsx(SignupForm, {
            title: copy.signup.title,
            email: email,
            buttonText: copy.signup.buttonText,
            loading: loadingAuth,
            onSubmit: onSignupFormSubmit
          })
        });

      case 'confirm-email-dialog':
        return /*#__PURE__*/_jsx("div", {
          style: {
            maxWidth: 705
          },
          children: /*#__PURE__*/_jsx(MagicLink, {
            email: email
          })
        });

      default:
        return null;
    }
  };

  return /*#__PURE__*/_jsx(Modal, {
    showModal: Boolean(step),
    setModal: setModal,
    children: renderSignuUpModalContent()
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    loadingAuth: state.auth.loading
  };
};

export default connect(mapStateToProps)(SignupFlow);